import { Droppable } from '@hello-pangea/dnd';
import styled from 'styled-components';

import { SmallTileList } from './SmallTileList.jsx';

const StyledTileListContainer = styled.div`
  height: 233px;
  margin-bottom: 16px;
`;

const SmallDroppableColumn = props => (
  <Droppable droppableId={props.columnId} direction="horizontal">
    {provided => (
      <StyledTileListContainer
        ref={provided.innerRef}
        {...provided.droppableProps}
      >
        <SmallTileList
          columnNumber={props.columnNumber}
          tiles={props.tiles}
          columnId={props.columnId}
        />
        {provided.placeholder}
      </StyledTileListContainer>
    )}
  </Droppable>
);

export { SmallDroppableColumn };
